// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"502fe5b4","513":"4649655d","621":"8f7247d8","703":"72718f67","787":"ad95bfd7"}[chunkId] + ".chunk.js";
};